<template>
  <div>
    <page-seo class="mb-10" :data="pageHomeSeo" />
    <featured-category class="mb-10" />
    <recommendation-business class="mb-10" />
    <our-partner />
  </div>
</template>

<script>
  import PageSeo from '@/components/form/PageSeo'
  import FeaturedCategory from './FeaturedCategory'
  import RecommendationBusiness from './RecommendationBusiness'
  import OurPartner from "./OurPartner";

  export default {
    components: {OurPartner, FeaturedCategory, RecommendationBusiness, PageSeo },
    computed: {
      pageHomeSeo: {
        get() {
          return this.$store.state.page.data.homeSeo
        }
      }
    }
  }
</script>
